import React from 'react';
import axios from 'axios';
import { config } from '../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../actions';
import '../../styles/elements/screen.scss';
import '../../styles/screens/integrations.scss';
import TranslationService from "../../app/services/TranslationService";
import { Confirmation } from "../Confirmation";
import { WebhookActionDialog } from "./WebhookActionDialog";
import {Button} from "../icymat-design/Button";
import {Label} from "../icymat-design/Label";


class WebhooksClass extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            available_webhooks: [
                'nyumba.online',
                'nyumba.offline',
                'nyumba.device.offline',
                'user.webhook.one',
                'user.webhook.two',
                'user.webhook.three'
            ],
            webhooks: [],
            add: null,
            remove: null
        }
    }

    /**
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== 'integrations' && this.props.view === 'integrations') {
        // if (prevProps.active !== this.props.active) {
            this.loadWebhooks();
        }
    };

    loadWebhooks = () => {
        this.props.preloaderShow()

        let that = this;
        axios.get(config.apiAddress + '/integrations/webhooks')
            .then(function (response) {
                that.setState({webhooks: response.data});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'common.actions.failed_to_load_data'));
            });
    }

    renderWebhooks = () => {
        let rows = [];

        let that = this;
        //all day
        this.state.available_webhooks.forEach(function(webhookName) {
            rows.push(<tr key={webhookName}>
                <td>{webhookName}</td>
                <td>
                    {that.renderActions(webhookName)}
                    <Button
                        color={'main'}
                        secondary={true}
                        text={TranslationService.trans(that.props.language, 'common.add')}
                        size={'sm'}
                        onClick={(event) => that.setState({add: config.apiAddress + '/integrations/webhooks/' + webhookName})}
                    />
                </td>
            </tr>);
        });

        return rows;
    }

    renderActions = (webhookName) => {
        let actions = [];

        let that = this;
        this.state.webhooks.forEach(function(webhook) {
            if (webhook.type === webhookName) {
                webhook.actions.forEach(function(action, key) {
                    actions.push(
                        <Label
                            color={'120-main'}
                            text={action.type}
                            title={action.content}
                            icon={that.getIconName(action.type)}
                            class={'action'}
                            onCancel={() => that.removeAction(webhook.type, key)}
                        />
                    );
                });
            }
        });

        return actions;
    }

    getIconName = (type) => {
        switch (type) {
            case 'sms':
                return 'imd-icon imd-icon-message-text-solid';

            case 'email':
                return 'imd-icon imd-icon-mail-solid';

            case 'test':
                return 'imd-icon imd-icon-code';

            default:
                return 'imd-icon imd-icon-terminal-tag'
        }
    }

    removeAction = (webhook, index) => {
        this.setState({remove: config.apiAddress + '/integrations/webhooks/' + webhook + '/' + index});
    }

    /**
     * @returns {XML}
     */
    render() {
        return (
            <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.props.active ? ' imd-active' : null)}>
                <table className="imd-table imd-table-bordered imd-border-color-accent imd-text-accent">
                    <thead>
                        <tr>
                            <th>{TranslationService.trans(this.props.language, 'common.name')}</th>
                            <th>{TranslationService.trans(this.props.language, 'common.actions')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.renderWebhooks()}
                    </tbody>
                </table>

                <Confirmation
                    address={this.state.remove}
                    onCancel={() => this.setState({remove: null})}
                    onSuccess={() => {this.setState({remove: null}); this.loadWebhooks()}}
                    onError={() => this.setState({remove: null})}
                />

                <WebhookActionDialog
                    address={this.state.add}
                    onCancel={() => this.setState({add: null})}
                    onSuccess={() => {this.setState({add: null}); this.loadWebhooks()}}
                    onError={() => this.setState({add: null})}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        language: TranslationService.getLanguage(state.user)
    }
};

export const WebhooksTab = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(WebhooksClass);
